import type { FC } from "react";

import styled from "styled-components";

import type { ITextfieldProps } from "@similarweb/ui-components";
import { Button, ButtonLabel, Textfield } from "@similarweb/ui-components";

import { ECategoryType } from "app/common/services/categoryService.types";
import { WebsiteListTypeSelectorContainer } from "app/components/website-list-selector/WebsiteListTypeSelectorContainer";
import { hasMarketingPermission } from "app/services/Workspaces.service";

import { ButtonGroup } from "../../ButtonsGroup/src/ButtonsGroup";
import I18n from "../../WithTranslation/src/I18n";

import { TableSelectionContainer } from "./StyledComponents";

interface ITableSelectionNewGroupProps {
    title: string;
    placeholder: string;
    onCancel: () => void;
    onSubmit: () => void;
    submitButtonDisabled?: boolean;
    groupName: string;
    onGroupNameChange: (e: FixmeType) => void;
    isLoading: boolean;
    error?: boolean;
    errorMessage?: string;
    onListTypeSelect?: (typeId: FixmeType) => void;
    groupType?: "website" | "keyword" | "segment";
    selectedListType?: ECategoryType;
}

const TextfieldStyled = styled(Textfield)<ITextfieldProps>`
    margin-bottom: 24px;
`;

const SelectorContainer = styled.div`
    margin-bottom: 24px;
`;

const SelectorLabel = styled.span`
    font-size: 12px;
    margin-bottom: 6px;
`;

export const TableSelectionNewGroup: FC<ITableSelectionNewGroupProps> = ({
    title = "",
    placeholder = "",
    onCancel,
    onSubmit,
    submitButtonDisabled,
    groupName,
    onGroupNameChange,
    isLoading,
    error,
    errorMessage,
    onListTypeSelect,
    groupType,
    selectedListType = ECategoryType.GENERAL_LIST,
}) => {
    return (
        <TableSelectionContainer>
            <TextfieldStyled
                error={error}
                errorMessage={errorMessage}
                placeholder={placeholder}
                onChange={onGroupNameChange}
                label={title}
                autoFocus={groupType === "segment"}
                dataAutomation="group-name-text-field"
            />
            {groupType === "website" && hasMarketingPermission() ? (
                <SelectorContainer>
                    <SelectorLabel>
                        <I18n>table.selection.newgroup.type.website.title</I18n>
                    </SelectorLabel>
                    <WebsiteListTypeSelectorContainer
                        selectedListType={selectedListType}
                        // @ts-ignore FIXME: strict migration - Type '((typeId) => void) | undefined' is not assignable to type '(typeId) => void' — onListTypeSelect is optional here but WebsiteListTypeSelectorContainer requires it; guaranteed defined by caller when the website type selector is shown
                        onListTypeSelect={onListTypeSelect}
                        disabled={false}
                    />
                </SelectorContainer>
            ) : null}
            <ButtonGroup>
                <Button
                    type="flat"
                    onClick={onCancel}
                >
                    <ButtonLabel>
                        <I18n>table.selection.newgroup.cancel</I18n>
                    </ButtonLabel>
                </Button>
                <Button
                    type="primary"
                    onClick={onSubmit}
                    isLoading={isLoading}
                    isDisabled={submitButtonDisabled}
                >
                    <ButtonLabel>
                        <I18n>table.selection.newgroup.confirm</I18n>
                    </ButtonLabel>
                </Button>
            </ButtonGroup>
        </TableSelectionContainer>
    );
};
TableSelectionNewGroup.displayName = "TableSelectionNewGroup";
